module.exports = __webpack_public_path__ + "img/ekd.c710b483.jpg";